import { Avatar, Button, Image, Input, List, Typography, message, theme, Modal, Form, Select, Divider, Space } from "antd";
import moment from "moment";
import { Comment } from '@ant-design/compatible';
import React, { useEffect, useState } from "react";
import useFetch from "../../_fetch";
import FileItem from "../../components/FilesItem";
import { saveAs } from 'file-saver';
import { RollbackOutlined, EditOutlined, DeleteOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { useGetAllDocuments, useUpdateFolder, useGetAllFolders, useGetAllFinancialYears, useGetAllClients } from "../../utils/queryUtils";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../components/loader";
import { setReloadComment } from "../../store/action/reload";

export default function FolderContent({ id, name, setShowFolderContent, toggle, setToggle }) {
    const _fetch = useFetch();
    const { token: { colorPrimary } } = theme.useToken();
    const [docsWithURL, setDocsWithURL] = useState([]);
    const dispatch = useDispatch()
    const { reloadComment } = useSelector(st => {
        return st.reload
    })
    const [edit, setEdit] = useState(false);
    const [page] = useState(1);
    const [loading, setLoading] = useState(false)
    const { fy: selectedFy } = useSelector(st => st.selected)
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [folderName, setFolderName] = useState(name);
    const { mutateAsync: updateFolder, isSuccess: updateFolderSuccess } = useUpdateFolder();

    // Move functionality states
    const [moveModalVisible, setMoveModalVisible] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [, setSelectAll] = useState(false);
    const [showSelectionBar, setShowSelectionBar] = useState(false);
    const [newFolder, setNewFolder] = useState(false);
    const [moving, setMoving] = useState(false);
    const [fy_id, setFy_id] = useState(null);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [selectedFY, setSelectedFY] = useState(null);

    const [form] = Form.useForm();
    const { Option } = Select;

    // Query hooks for move functionality
    const { name: selectedCompany } = useSelector(st => st.selected.company || {});
    const all_clients_from_cache = useGetAllClients(selectedCompany);
    const all_clients = all_clients_from_cache?.data?.data;
    const financialYearsData = useGetAllFinancialYears(selectedEntity);
    const all_fys = financialYearsData?.data;
    const foldersDataCache = useGetAllFolders(fy_id);
    const all_folders = foldersDataCache?.data;

    const handleTableChange = (pagination, filters, sorter) => {
        try {
            setCurrentPage(pagination);
        }
        catch (err) {
            console.error(err)
        }
    };
    const data = useGetAllDocuments(id, currentPage);

    async function init() {
        setLoading(true)
        let tempDoc = [];
        const documentsData = data?.data;
        console.log(documentsData, 'documentsData')
        let documents = documentsData?.data;
        setPagination((prev) => ({
            ...prev,
            current: documentsData?.pagination?.current,
            total: documentsData?.pagination?.total
        }));
        for (let i = 0; i < documents?.length; i += 1) {
            tempDoc[i] = documents[i];
            let res = await _fetch(`${process.env.REACT_APP_API_URL}/file?document_id=${tempDoc[i]._id}`)
            res = await res.json();
            if (res.success)
                tempDoc[i].files = res.response;
        }
        setDocsWithURL(tempDoc);
        setLoading(false);
    }

    async function downloadZip() {
        await _fetch(`${process.env.REACT_APP_API_URL}/file/documents/zip?document_ids=${docsWithURL.map(d => d._id).join(',')}`).then((res) => {
            res.blob().then(blob => {
                saveAs(blob, `efiles_${name}`)
            })
        });
    }

    const handleEdit = async () => {
        try {
            const payload = {
                id: id,
                name: folderName,
                fy_id: selectedFy._id,
                page: page
            }
            const res = await updateFolder(payload);
            if (res != null || updateFolderSuccess) {
                message.success("Folder Name edited successfully");
            }

            setToggle((pre) => !pre);
            setEdit(false);
        } catch (e) {
            console.error(e);
            message.error("Failed to update folder name");
        }
    }

    const handleDeleteDocument = async (documentId) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this document?',
            content: 'This action cannot be undone.',
            okText: 'Yes, Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    const response = await _fetch(`${process.env.REACT_APP_API_URL}/document/${documentId}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    const result = await response.json();

                    if (result.success) {
                        message.success('Document deleted successfully');
                        data.refetch();
                    } else {
                        message.error('Failed to delete document');
                    }
                } catch (error) {
                    console.error('Error deleting document:', error);
                    message.error('Error deleting document');
                }
            },
        });
    };

    const toggleDocumentSelection = (documentId) => {
        setSelectedDocuments(prev =>
            prev.includes(documentId)
                ? prev.filter(id => id !== documentId)
                : [...prev, documentId]
        );

        const newSelectedDocuments = selectedDocuments.includes(documentId)
            ? selectedDocuments.filter(id => id !== documentId)
            : [...selectedDocuments, documentId];

        setShowSelectionBar(newSelectedDocuments.length > 0);
    };


    const handleMove = () => {
        setMoveModalVisible(true);
    };

    const handleSingleDocumentMove = (documentId, e) => {
        e.stopPropagation();
        setSelectedDocuments([documentId]);
        setMoveModalVisible(true);
    };

    const handleEntityChange = (selectedId) => {
        const selectedObject = all_clients?.find(client => client._id === selectedId);
        if (selectedObject) {
            setSelectedEntity(selectedObject);
            financialYearsData?.refetch();
            form.setFieldsValue({ financialYear: undefined });
        }
    };

    const handleFYChange = (value) => {
        setFy_id(value);
        setSelectedFY(value);
        foldersDataCache?.refetch();
        form.setFieldsValue({ folder_id: undefined });
    };

    async function getFolder(name) {
        let body = {
            name: name,
            fy_id,
        }
        try {
            let res = await _fetch(`${process.env.REACT_APP_API_URL}/folder`,
                {
                    method: 'POST',
                    body
                }
            );
            let data = await res.json();
            if (data) {
                return data._id
            } else {
                console.error(data)
                message.error(data.response);
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    const confirmMove = async () => {
        if (!selectedEntity || !selectedFY) {
            message.error('Please select both entity and financial year');
            return;
        }
        if (!selectedDocuments.length) {
            message.error('Please select at least one document');
            return;
        }
        if (!form.getFieldValue('new_folder') && !form.getFieldValue('folder_id')) {
            message.error('Please select a folder or create a new one first');
            return;
        }

        setMoving(true);

        try {
            let folderId;

            if (newFolder && form.getFieldValue('new_folder')) {
                folderId = await getFolder(form.getFieldValue('new_folder'));
                if (!folderId) {
                    message.error('Failed to create folder');
                    return;
                }
            } else {
                folderId = form.getFieldValue('folder_id');
            }

            for (const documentId of selectedDocuments) {
                const moveData = {
                    entity_id: selectedEntity._id,
                    fy_id: selectedFY._id || selectedFY,
                    folder_id: folderId,
                };

                const moveRes = await _fetch(
                    `${process.env.REACT_APP_API_URL}/document/${documentId}`,
                    {
                        method: 'PATCH',
                        body: moveData,
                    }
                );

                if (!moveRes.ok) {
                    message.error(`Failed to move document: ${documentId}`);
                }
            }

            await data.refetch();

            setSelectedDocuments([]);
            setSelectAll(false);
            setShowSelectionBar(false);
            setMoveModalVisible(false);
            setSelectedEntity(null);
            setSelectedFY(null);
            form.resetFields();

            message.success(`Moved ${selectedDocuments.length} document(s) successfully`);
        } catch (error) {
            console.error('Move error:', error);
            message.error('Failed to move documents');
        } finally {
            setMoving(false);
        }
    };

    useEffect(() => {
        init();
    }, [toggle, id, currentPage, data?.data])

    useEffect(() => {
        if (reloadComment === true) {
            data.refetch();
            dispatch(setReloadComment(false));
        }
    }, [reloadComment])

    return (
        <React.Fragment>

            {showSelectionBar && (
                <div style={{
                    marginBottom: 16,
                    backgroundColor: colorPrimary,
                    color: 'white',
                    borderRadius: '8px',
                    padding: '16px',
                    margin: '0 16px 16px 16px'
                }}>
                    <Space size="large" style={{ width: '100%', justifyContent: 'space-between' }}>
                        <Space size="large">
                            <span style={{ color: 'white' }}>
                                {selectedDocuments.length} document(s) selected
                            </span>
                        </Space>

                        <Button
                            type="primary"
                            style={{ background: 'white', color: colorPrimary, border: 'none' }}
                            onClick={handleMove}
                            disabled={moving}
                            icon={<FolderOpenOutlined />}
                        >
                            Move Documents
                        </Button>
                    </Space>
                </div>
            )}

            <div class="w-100 d-flex justify-content-between px-3">
                <Button type="link"
                    onClick={() => setShowFolderContent({})}
                    style={{ color: colorPrimary }}
                >
                    <RollbackOutlined /> Back
                </Button>
                {edit === false ?
                    <Typography.Title level={4}>
                        {folderName}
                        {" "}
                        <span><EditOutlined style={{ color: colorPrimary }}
                            onClick={() => setEdit(true)}
                        /></span>
                    </Typography.Title>
                    :
                    <Typography.Title level={4}>
                        <Input
                            autoFocus
                            variant="borderless"
                            value={folderName}
                            style={{ width: '40%' }}
                            onChange={(e) => setFolderName(e.target.value)} />
                        <Button onClick={handleEdit}>Submit</Button>
                    </Typography.Title>
                }

                <Button onClick={() => downloadZip()} type="primary">Download</Button>
            </div>

            {loading ? <Loader /> :
                <List
                    className="p-4"
                    pagination={{
                        current: pagination?.current,
                        pageSize: pagination?.pageSize,
                        total: pagination?.total,
                        showSizeChanger: false,
                        onChange: handleTableChange,
                        onError: (err) => { console.error(err) }
                    }}
                    dataSource={docsWithURL}
                    renderItem={(doc) => {
                        return (
                            <div
                                style={{
                                    border: selectedDocuments.includes(doc._id) ? `2px solid ${colorPrimary}` : '1px solid #f0f0f0',
                                    borderRadius: '8px',
                                    marginBottom: '16px',
                                    padding: '8px',
                                    cursor: 'pointer'
                                }}
                                onClick={() => toggleDocumentSelection(doc._id)}
                            >
                                <Comment
                                    author={`${doc.created_by?.first_name} ${doc.created_by?.last_name}`}
                                    avatar={
                                        <Avatar shape='square'>
                                            {doc.created_by?.first_name}
                                            {doc.created_by?.last_name}
                                        </Avatar>
                                    }
                                    content={doc.comment}
                                    datetime={moment(doc.createdAt).format("DD/MM/YYYY hh:mm A")}
                                    actions={[
                                        <Button
                                            type="link"
                                            icon={<FolderOpenOutlined />}
                                            onClick={(e) => handleSingleDocumentMove(doc._id, e)}
                                        >
                                            Move
                                        </Button>,
                                        <Button
                                            type="link"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteDocument(doc._id);
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    ]}
                                >
                                    <div>
                                        <br />
                                        <Image.PreviewGroup>
                                            {
                                                doc?.files?.map((file, index) => (
                                                    <FileItem file={file} key={`file-${index}`} />
                                                ))
                                            }
                                        </Image.PreviewGroup>
                                    </div>
                                </Comment>
                            </div>
                        )
                    }}
                />
            }

            {/* Move Modal */}
            <Modal
                title="Move Documents"
                open={moveModalVisible}
                onOk={confirmMove}
                onCancel={() => {
                    setMoveModalVisible(false);
                    setSelectedEntity(null);
                    setSelectedFY(null);
                    setNewFolder(false);
                    form.resetFields();
                }}
                okText="Move"
                confirmLoading={moving}
                width={400}
            >
                <div style={{ marginBottom: 16 }}>
                    <Typography.Text>Move {selectedDocuments.length} selected document(s) to:</Typography.Text>
                </div>

                <Form layout="vertical" form={form}>
                    <Form.Item
                        label="Entity"
                        name="client_id"
                        rules={[{ required: true, message: 'Please select an entity' }]}
                    >
                        <Select showSearch optionFilterProp="label" onChange={handleEntityChange}>
                            {all_clients?.map(e => (
                                <Option value={e._id} key={e._id} label={e.title}>{e.title}</Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.client_id !== currentValues.client_id}
                    >
                        {({ getFieldValue }) => (
                            <Form.Item
                                label="Financial Year"
                                name="financialYear"
                                rules={[{ required: true, message: 'Financial Year is required' }]}
                            >
                                <Select onChange={handleFYChange}>
                                    {all_fys?.data?.map((fy) => (
                                        <Option value={fy._id} key={fy._id}>
                                            <div style={{ display: 'flex', gap: '1rem', fontWeight: 500 }}>
                                                <span>{moment(fy.start).format('YYYY')} - {moment(fy.end).format('YY')}</span>
                                                | <span> {fy.fy_type}</span>
                                                |<span> {fy.period_type}</span>
                                            </div>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                    </Form.Item>

                    {!newFolder ? (
                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) =>
                                prevValues.financialYear !== currentValues.financialYear
                            }
                        >
                            {({ getFieldValue }) => (
                                <Form.Item
                                    label="Folder"
                                    name="folder_id"
                                    rules={[{ required: !newFolder, message: 'Please select a folder' }]}
                                >
                                    <Select
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                <Divider style={{ margin: '8px 0' }} />
                                                <Button
                                                    type="link"
                                                    style={{ color: colorPrimary }}
                                                    onClick={() => {
                                                        setNewFolder(true);
                                                        form.setFieldsValue({ folder_id: undefined });
                                                    }}
                                                >
                                                    + Create new folder
                                                </Button>
                                            </>
                                        )}
                                    >
                                        {all_folders?.map((e) => (
                                            <Option value={e._id} key={e._id} label={e.name}>
                                                {e.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            )}
                        </Form.Item>
                    ) : (
                        <Form.Item
                            label="Create New Folder"
                            name="new_folder"
                            rules={[{ required: newFolder, message: 'Please enter a folder name' }]}
                        >
                            <Input
                                placeholder="Enter folder name"
                                suffix={
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={() => {
                                            setNewFolder(false);
                                            form.setFieldsValue({ new_folder: undefined });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                }
                            />
                        </Form.Item>
                    )}
                </Form>
            </Modal>
        </React.Fragment>
    )
}